const validateEmail = (emailId) => {
  const regEmail = /\S+@\S+\.\S+/;
  return regEmail.test(emailId);
};

const validateMobileNumber = (number) => {
  const regex = /^\+?[1-9][0-9]{9}$/;
  return regex.test(number);
};

const validateOTP = (otp) => {
  const regex = /^\d{4}$/;
  return regex.test(otp);
};

export { validateEmail, validateMobileNumber, validateOTP };
